import LayersPanelHandoff from 'marketing-website/media/images/pages/resources/layers-panel-handoff.png';
import MixedIo from 'marketing-website/media/images/pages/resources/freehand-marvel-prototyping.png';
import UserTestsZoom from 'marketing-website/media/images/pages/resources/user-tests-zoom.png';
import LaunchUserTestsDirectly from 'marketing-website/media/images/pages/resources/launch-user-tests-directly.png';
import OrganisingWorkflow from 'marketing-website/media/images/pages/resources/organising-workflow-folders.png';
import FoldersShare from 'marketing-website/media/images/pages/resources/folders-organise-share-your-projects.png';
import RemoteTests from 'marketing-website/media/images/pages/resources/create-remote-usability-tests.png';
import PitchPrototypes from 'marketing-website/media/images/pages/resources/pitch-using-prototypes.png';
import UsingGoals from 'marketing-website/media/images/pages/resources/using-goals.png';
import SectionsResources from 'marketing-website/media/images/pages/resources/sections.png';
import GuerillaUserTests from 'marketing-website/media/images/pages/resources/how-to-run-guerilla-user-tests.png';
import DesignThinkingWorkshop from 'marketing-website/media/images/pages/resources/design-thinking-workshop.png';

const productUpdatesData = [
  {
    excerpt: 'We’ve just launched a layers panel for Handoff!',
    image: {
      alt: 'Layers Panel Handoff',
      src: LayersPanelHandoff,
    },
    url: 'https://marvelapp.com/blog/layers-panel-handoff/',
  },
  {
    excerpt:
      'Mixed.io + Marvel – Remote collaboration on your prototype designs in real-time',
    image: {
      alt: 'Remote collaboration on your prototype designs',
      src: MixedIo,
    },
    url:
      'https://marvelapp.com/blog/mixed-io-marvel-collaborate-prototype-designs-real-time/',
  },
  {
    excerpt:
      'How to run remote usability tests using Marvel + Zoom or Google Hangouts',
    image: {
      alt: 'Test your application remotely',
      src: UserTestsZoom,
    },
    url:
      'https://marvelapp.com/blog/run-remote-usability-tests-using-marvel-zoom-google-hangouts/',
  },
  {
    excerpt: 'Launch user tests directly from the Marvel iOS app!',
    image: {
      alt: 'Launch User Tests from the Marvel iOS app',
      src: LaunchUserTestsDirectly,
    },
    url:
      'https://marvelapp.com/blog/launch-user-tests-directly-marvel-ios-app/',
  },
  {
    excerpt: 'Organising clients, features, departments and work with folders',
    image: {
      alt: 'Organise with Folders',
      src: OrganisingWorkflow,
    },
    url: 'https://marvelapp.com/blog/organising-workflow-folders/',
  },
  {
    excerpt: 'How to create remote usability tests in Marvel',
    image: {
      alt: 'Create Remote Usability Tests',
      src: RemoteTests,
    },
    url: 'https://marvelapp.com/blog/create-remote-usability-tests-marvel/',
  },
  {
    excerpt: 'How to organise and share your projects with folders',
    image: {
      alt: 'Organise And Share Your Projects',
      src: FoldersShare,
    },
    url:
      'https://marvelapp.com/blog/how-to-organise-share-your-projects-with-folders/',
  },
  {
    excerpt:
      'How to pitch and present ideas using prototypes to clients and stakeholders',
    image: {
      alt: 'Present Ideas Using Prototypes',
      src: PitchPrototypes,
    },
    url:
      'https://marvelapp.com/blog/pitch-present-ideas-using-prototypes-clients-stakeholders/',
  },
  {
    excerpt: 'Using goals to determine your best performing prototype',
    image: {
      alt: 'Determine Your Best Performing Prototype',
      src: UsingGoals,
    },
    url:
      'https://marvelapp.com/blog/using-goals-determine-best-performing-prototype/',
  },
  {
    excerpt: '5 great ways to use sections in your Marvel projects',
    image: {
      alt: 'Use Sections in Your Marvel Projects',
      src: SectionsResources,
    },
    url:
      'https://marvelapp.com/blog/5-great-ways-to-use-sections-in-your-marvel-projects/',
  },
  {
    excerpt: 'How to run guerrilla user testing with Marvel',
    image: {
      alt: 'Run Guerrilla User Testing',
      src: GuerillaUserTests,
    },
    url:
      'https://marvelapp.com/blog/how-to-run-guerrilla-user-testing-with-marvel/',
  },
  {
    excerpt: 'How to run your first design thinking workshop using Marvel',
    image: {
      alt: 'Run Your First Design Thinking Workshop',
      src: DesignThinkingWorkshop,
    },
    url:
      'https://marvelapp.com/blog/run-first-design-thinking-workshop-prototypes/',
  },
];
export default productUpdatesData;



// WEBPACK FOOTER //
// ./src/configs/pages/resources/productUpdatesData.js